// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Inventory_modal__img__BcFb5 {
  height: 7.5rem;
  margin-bottom: 3rem;
}

.Inventory_main_nav__gKIqG {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  padding: 0 2rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Inventory_main_nav__gKIqG > :not(:last-child) {
  margin-right: 3rem;
}
.Inventory_main_nav_group__t-7Sy {
  position: relative;
}
.Inventory_main_nav_more__WQuzL {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Inventory_main_nav_more__WQuzL > :not(last-child) {
  margin-bottom: 1rem;
}
.Inventory_main_nav_item__vvwEF {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Inventory_main_nav_item_active__kUACa {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Inventory_main_nav_item__vvwEF:hover, .Inventory_main_nav_item__vvwEF:focus, .Inventory_main_nav_item__vvwEF:focus-visible, .Inventory_main_nav_item__vvwEF:focus-within {
  font-weight: 700;
  color: var(--color-primary);
  border-bottom: solid 2px var(--color-primary);
}
.Inventory_main__metrics__55glC {
  width: 100%;
  display: grid;
  text-align: center;
  box-sizing: border-box;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 50em) {
  .Inventory_main__metrics__55glC {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media only screen and (max-width: 37.5em) {
  .Inventory_main__metrics__55glC {
    grid-template-columns: repeat(2, 1fr);
  }
}
.Inventory_main__metrics_container__k3QsK {
  box-sizing: border-box;
  padding: 2rem;
  width: 100%;
  background-color: var(--color-white);
  border-radius: 2rem;
}
.Inventory_main__metrics_lightBlue__\\+kaQv {
  background-color: var(--color-primary-3);
}
.Inventory_main__metrics_grey__ObfM4 {
  background-color: var(--color-grey-2);
}
.Inventory_main__metrics_lightBlue2__E3ZWe {
  background-color: var(--color-primary-7);
}
.Inventory_main__metrics_red__g0AfG {
  background-color: var(--color-error);
  color: var(--color-white);
}
.Inventory_main__metrics_green__GQfvC {
  background-color: var(--color-success);
  color: var(--color-white);
}
.Inventory_main__metrics_yellow__0X\\+v4 {
  background-color: var(--color-yellow);
}
.Inventory_main__dropdowns__XlsdE {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
  width: 100%;
}
@media only screen and (max-width: 43.75em) {
  .Inventory_main__dropdowns__XlsdE {
    flex-direction: column;
    align-items: center;
  }
}
.Inventory_main__dropdowns__XlsdE > :not(last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Inventory_main__dropdowns__XlsdE > :not(last-child) {
    margin-right: none;
  }
}

.Inventory_threeCards__PK75t {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Inventory_threeCards__PK75t {
    grid-template-columns: repeat(2, 1fr);
  }
}

.Inventory_singleCard__5N9ML {
  width: 100%;
  background-color: var(--color-white);
  padding: 2rem;
  border-radius: 2rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}

.Inventory_payroll_table__HTafZ {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.Inventory_payroll_table__HTafZ table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.Inventory_payroll_table__HTafZ table tr {
  display: grid;
  grid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .Inventory_payroll_table__HTafZ table tr {
    grid-template-columns: 15% 40% 30% 15%;
  }
}
.Inventory_payroll_table__HTafZ table th,
.Inventory_payroll_table__HTafZ table td {
  padding: 2.2rem 2rem;
}
.Inventory_payroll_table__HTafZ table th {
  font-weight: 700;
}
.Inventory_payroll_table__HTafZ table td {
  cursor: pointer;
}
.Inventory_payroll_table__HTafZ table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Inventory_payroll_table__HTafZ table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Inventory_payroll_table__HTafZ table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}

.Inventory_status__9HNE1 {
  box-sizing: border-box;
  width: 5vw;
  height: 2vw;
  color: var(--color-error);
}
.Inventory_status__pending__TT0cd {
  color: var(--color-yellow-3);
}
.Inventory_status__paid__DtKxT {
  color: var(--color-green);
}
.Inventory_status__failed__KVuOW {
  color: var(--color-error);
}

.Inventory_employee__list__Scd2i {
  width: 38rem;
  margin-top: 5rem;
}
.Inventory_employee__list__Scd2i li {
  list-style: none;
  cursor: pointer;
}
.Inventory_employee__list__Scd2i li:hover {
  font-weight: 700;
  color: var(--color-primary);
}
.Inventory_employee__list_line__q\\+p7k {
  border-top: 1px solid var(--color-primary);
  margin: 2rem 0;
}
.Inventory_employee__avatar__-o78z {
  width: 9rem;
}
.Inventory_employee__avatar_container__uaiJ0 {
  width: 10rem;
  height: 10rem;
  border-radius: 7rem;
  border: 1px solid var(--color-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
.Inventory_employee__details__tcRZo {
  width: 38rem;
}
.Inventory_employee__editButton__Q15tr {
  position: relative;
  right: 17rem;
  display: flex;
  font-size: 2.5rem;
  align-items: center;
  cursor: pointer;
}
.Inventory_employee__editButton__Q15tr > :not(:last-child) {
  margin-right: 1rem;
}
.Inventory_employee__terminate__mdIL0 {
  display: flex;
  flex-direction: column;
  width: 38rem;
}
.Inventory_employee__terminate__mdIL0 > :not(:last-child) {
  margin-bottom: 1rem;
}
.Inventory_employee_table__snPK- {
  width: 100%;
  margin-top: 3rem;
  font-size: var(--default-font-small);
}
.Inventory_employee_table__snPK- table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
}
.Inventory_employee_table__snPK- table tr {
  display: grid;
  grid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;
  padding: 0 1rem;
  align-items: center;
}
@media only screen and (max-width: 50em) {
  .Inventory_employee_table__snPK- table tr {
    grid-template-columns: repeat(2, 40%) 20%;
  }
}
.Inventory_employee_table__snPK- table th,
.Inventory_employee_table__snPK- table td {
  padding: 2.2rem 1rem;
}
.Inventory_employee_table__snPK- table th {
  font-weight: 700;
}
.Inventory_employee_table__snPK- table td {
  cursor: pointer;
}
.Inventory_employee_table__snPK- table tbody > :not(:last-child) {
  margin-bottom: 1.5rem;
}
.Inventory_employee_table__snPK- table tbody tr {
  background-color: var(--color-primary-3);
  border-radius: 1.3rem;
}
.Inventory_employee_table__snPK- table tbody tr:nth-child(even) {
  background-color: var(--color-primary-7);
  border-radius: 1.3rem;
}
.Inventory_employee_table__snPK- table tbody tr > :last-child {
  font-weight: 700;
}

.Inventory_crumbs__y0n8w {
  display: flex;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.Inventory_crumbs__y0n8w > :not(:last-child) {
  margin-right: 2rem;
}
.Inventory_crumbs__main__IBpZC {
  content: "";
  height: 2rem;
  width: 2rem;
  border-radius: 2rem;
  background-color: var(--color-grey);
}
.Inventory_crumbs__active__bWopu {
  width: 5rem;
  background-color: var(--color-primary);
}

.Inventory_checks__frlcO {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.Inventory_checks_group__v52ga {
  width: 38rem;
}

.Inventory_gp__uLuUf {
  width: 40rem;
}
.Inventory_gp__vb__oKckA {
  position: relative;
  left: 20rem;
}
.Inventory_gp__vps__XpZY5 {
  position: relative;
  left: 16.5rem;
}
.Inventory_gp__top__m-cDK {
  display: flex;
  justify-content: space-between;
  width: 44rem;
  margin-bottom: 3rem;
}
.Inventory_gp__uLuUf table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font-small);
}
.Inventory_gp__uLuUf table tr {
  display: grid;
  grid-template-columns: 2.6fr repeat(2, 1.2fr);
  align-items: center;
  border-bottom: 1px solid var(--color-primary);
}
.Inventory_gp__uLuUf table th {
  font-weight: 700;
  color: var(--color-primary);
}
.Inventory_gp__uLuUf table td {
  cursor: pointer;
}
.Inventory_gp__uLuUf table tbody > :first-child {
  margin-top: 1rem;
}
.Inventory_gp__uLuUf table tbody > * {
  padding: 1rem 0;
}
.Inventory_gp__uLuUf table tbody tr > :first-child {
  font-weight: 700;
}

.Inventory_ps__gmEJu {
  width: 40rem;
}
.Inventory_ps__breakdown__DkKwR {
  width: 38rem;
}
.Inventory_ps__breakdown_sm__-XVs5 {
  font-size: var(--default-font-small);
}
.Inventory_ps__breakdown_bdr__9Ob8d {
  border-bottom: 1px solid var(--color-primary);
}
.Inventory_ps__breakdown_total__ci1op {
  font-size: var(--default-font-small);
}
.Inventory_ps__breakdown__DkKwR table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: left;
  font-size: var(--default-font);
}
.Inventory_ps__breakdown__DkKwR table thead tr,
.Inventory_ps__breakdown__DkKwR table tbody tr {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
}
.Inventory_ps__breakdown__DkKwR table thead tr > :first-child,
.Inventory_ps__breakdown__DkKwR table tbody tr > :first-child {
  justify-self: start;
  font-weight: 400;
}
.Inventory_ps__breakdown__DkKwR table thead tr > :last-child,
.Inventory_ps__breakdown__DkKwR table tbody tr > :last-child {
  justify-self: end;
  font-weight: 700;
}
.Inventory_ps__breakdown__DkKwR table thead > *,
.Inventory_ps__breakdown__DkKwR table tbody > * {
  padding: 1rem 0;
}
.Inventory_ps__breakdown__DkKwR table th {
  color: var(--color-primary);
}

.Inventory_mp__Yons6 {
  width: 38rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Inventory_success__2VUDc {
  height: 27rem;
  margin-bottom: 3rem;
}

.Inventory_simpleTable__u0m6Y {
  width: 100%;
  margin-top: 3rem;
  font-size: 1.2rem;
}
.Inventory_simpleTable__u0m6Y table {
  width: 100%;
  max-width: 100%;
  border: none;
  border-collapse: collapse;
  box-sizing: border-box;
  text-align: center;
  margin-top: 2rem;
}
.Inventory_simpleTable__u0m6Y table tr {
  padding: 0 1rem;
  align-items: center;
}
.Inventory_simpleTable__u0m6Y table th,
.Inventory_simpleTable__u0m6Y table td {
  padding: 1.2rem 2rem;
}
.Inventory_simpleTable__u0m6Y table th {
  font-weight: 700;
}
.Inventory_simpleTable__u0m6Y table thead {
  margin-bottom: 2rem;
}
.Inventory_simpleTable__u0m6Y table thead tr {
  background-color: var(--color-dark);
  border-radius: 1rem;
  color: var(--color-white);
}
.Inventory_simpleTable__u0m6Y table tbody tr {
  background-color: var(--color-white);
}
.Inventory_simpleTable__u0m6Y table tbody tr:nth-child(even) {
  background-color: var(--color-table-grey);
}
.Inventory_simpleTable__u0m6Y table .Inventory_pending__04Uz6 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-yellow);
  color: var(--color-dark);
  margin-top: 0.7rem;
  width: 100%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_paid__fRn2P {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-success);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_low__S26L3 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-error);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 60%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_inStock__DqGb4 {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-primary-8);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 60%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_others__B7\\+3e {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-dark);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_change__P4XGD {
  display: inline-flex;
  justify-content: center;
  line-height: 1;
  font-size: 1rem;
  border-radius: 1rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  margin-top: 0.7rem;
  width: 100%;
}
.Inventory_simpleTable__u0m6Y table .Inventory_action__text__uyeSY {
  font-weight: 600;
  color: var(--color-primary);
  text-decoration: underline;
  cursor: pointer;
}

.Inventory_filter__qhLnu {
  position: absolute;
  width: fit-content;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 3;
}
@media only screen and (max-width: 31.25em) {
  .Inventory_filter__qhLnu {
    top: 95%;
  }
}
.Inventory_filter_title__u07\\+2 {
  width: 100%;
  font-size: var(--default-font-small);
  background-color: var(--color-light);
  padding: 1rem;
}
.Inventory_filter_title__u07\\+2 > :not(:last-child) {
  margin-right: 1.5rem;
}
.Inventory_filter_group__zR2NY {
  display: flex;
  flex-wrap: wrap;
}
.Inventory_filter_group__zR2NY > :not(:last-child) {
  margin-right: 1rem;
}
.Inventory_filter_item__eDDPY {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  margin-bottom: 1rem;
}
.Inventory_filter_selectedItem__5p3Lk {
  font-size: 1.2rem;
  padding: 0.5rem;
  border: 1px solid var(--color-dark);
  border-radius: 0.8rem;
  cursor: pointer;
  color: var(--color-white);
  font-weight: 700;
  background-color: var(--color-dark);
  margin-bottom: 1rem;
}

.Inventory_cpt__XGAwb {
  display: flex;
  font-size: var(--default-font-small);
  width: 38rem;
  overflow-x: scroll;
}
.Inventory_cpt__XGAwb::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
}
.Inventory_cpt__XGAwb::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
.Inventory_cpt_action__Ctc3f {
  font-weight: 700;
  color: var(--color-primary);
  cursor: pointer;
  text-decoration: underline;
}
.Inventory_cpt__XGAwb tr {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2rem;
}
.Inventory_cpt__XGAwb thead {
  background-color: var(--color-grey-3);
  width: 19rem;
  position: fixed;
  z-index: 2;
}
.Inventory_cpt__XGAwb tbody {
  position: relative;
  left: 50%;
  display: flex;
}
.Inventory_cpt__XGAwb tbody tr {
  background-color: var(--color-light);
  width: 19rem;
}
.Inventory_cpt__XGAwb tbody tr:nth-child(even) {
  background-color: var(--color-white);
}

.Inventory_beneficiary__vJQo- {
  display: grid;
  grid-template-columns: 1fr 1fr;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  width: 38rem;
  margin-bottom: 3rem;
  cursor: pointer;
}
.Inventory_beneficiary__vJQo- > * {
  padding: 1rem 0 1rem 0;
  text-align: center;
}
.Inventory_beneficiary__saved__Lxh-c {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Inventory_beneficiary__saved_b__0fv\\+O {
  border: 1px solid var(--color-primary);
  border-radius: 1rem 0 0 1rem;
  transition: all 0.4s;
}
.Inventory_beneficiary__new__YHhKP {
  border: 1px solid var(--color-primary);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}
.Inventory_beneficiary__new_b__q5FGC {
  background-color: var(--color-primary);
  color: var(--color-white);
  border-radius: 0 1rem 1rem 0;
  transition: all 0.4s;
}

.Inventory_unit_group__E8yp\\+ {
  width: 38rem;
  display: grid;
  grid-template-columns: repeat(2, 50%);
  gap: 2rem;
}
.Inventory_unit_card__7MkzH {
  background-color: var(--color-primary-3);
  padding: 2rem;
  box-sizing: border-box;
  border-radius: 2rem;
  font-size: 4rem;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--color-primary);
  cursor: pointer;
  transition: all 0.4s;
}
.Inventory_unit_card__7MkzH:hover {
  background-color: var(--color-primary-7);
}

.Inventory_searchbtnsection__eyUa2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 2rem;
  margin-top: 2rem;
}
.Inventory_searchbtnsection__eyUa2 > :not(:last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Inventory_searchbtnsection__eyUa2 > :not(:last-child) {
    margin-right: 0;
  }
  .Inventory_searchbtnsection__eyUa2 {
    flex-direction: column;
    gap: 2rem;
  }
}

.Inventory_addProduct__beside__WhMGr {
  display: flex;
  justify-content: space-between;
  width: 38rem;
  margin-bottom: 3rem;
  margin-top: 3rem;
}
.Inventory_addProduct__note__Jw0NN {
  width: 38rem;
}
.Inventory_addProduct__variation__C4kUE {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;
  padding: 10px 20px;
  background-color: var(--color-primary-09);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
}
.Inventory_addProduct__variation_info__lbRNz {
  flex: 0 0 50%;
}
.Inventory_addProduct__variation_info_price__Im0V5 {
  display: flex;
  align-items: center;
}
.Inventory_addProduct__variation_info_price__Im0V5 svg {
  margin-left: auto;
  color: var(--color-dark);
}

.Inventory_imageUpload__6Wnl1 {
  height: 10rem;
}

.Inventory_lengthColor__6bEy1 {
  color: var(--color-error);
}

.Inventory_middleButtons__SqjPY {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.Inventory_middleButtons__SqjPY > :not(:last-child) {
  margin-right: 2rem;
}
@media only screen and (max-width: 31.25em) {
  .Inventory_middleButtons__SqjPY {
    flex-direction: column;
    align-items: center;
  }
  .Inventory_middleButtons__SqjPY > :not(:last-child) {
    margin-right: 0;
    margin-bottom: 2rem;
  }
}

.Inventory_selectCurrency__UcGSt {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Inventory_selectCurrency__text__XQE1q {
  display: flex;
  margin-left: 1rem;
}
.Inventory_selectCurrency__icon__49ugK {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Inventory_selectCurrency__icon__49ugK:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Inventory_selectCurrency__icon_active__XOWgO {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Inventory_selectCurrency__list__ax0Xj {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Inventory_selectCurrency__list_active__6b0QH {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Inventory_selectCurrency__list__ax0Xj li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Inventory_selectCurrency__list__ax0Xj li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Inventory_searchContainer__7Yhbn {
  display: flex;
  justify-self: center;
  max-width: fit-content;
}

.Inventory_searchAndFilter__LUUhY {
  display: flex;
  gap: 2rem;
  margin-top: 4rem;
}
@media only screen and (max-width: 50em) {
  .Inventory_searchAndFilter__LUUhY {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.Inventory_card__ecmWq {
  width: 38rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}
.Inventory_card_top__MELu6 {
  display: flex;
  justify-content: space-between;
}

.Inventory_type__VhV6F {
  margin-bottom: 2rem;
  margin-top: 2rem;
}
.Inventory_type_rcb__6hWNV {
  display: flex;
  gap: 1rem;
  align-items: center;
  width: 38rem;
  margin-top: 2rem;
}

.Inventory_btnClass__ekxvF {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}
@media only screen and (max-width: 43.75em) {
  .Inventory_btnClass__ekxvF {
    align-items: center;
    flex-direction: column-reverse;
    gap: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Inventory/Inventory.module.scss"],"names":[],"mappings":"AAGC;EACC,cAAA;EACA,mBAAA;AAFF;;AAOC;EACC,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EAEA,oCAAA;EACA,0CAAA;EACA,4BAAA;AALF;AAOE;EACC,kBAAA;AALH;AAQE;EACC,kBAAA;AANH;AASE;EACC,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AAPH;AASG;EACC,mBAAA;AAPJ;AAWE;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AATH;AAeG;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AAbJ;AAgBG;EAIC,gBAAA;EACA,2BAAA;EACA,6CAAA;AAjBJ;AAsBC;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AApBF;AAsBE;EARD;IASE,qCAAA;EAnBD;AACF;AAqBE;EAZD;IAaE,qCAAA;EAlBD;AACF;AAqBE;EACC,sBAAA;EACA,aAAA;EACA,WAAA;EACA,oCAAA;EACA,mBAAA;AAnBH;AA2BE;EACC,wCAAA;AAzBH;AA4BE;EACC,qCAAA;AA1BH;AA6BE;EACC,wCAAA;AA3BH;AA8BE;EACC,oCAAA;EACA,yBAAA;AA5BH;AA+BE;EACC,sCAAA;EACA,yBAAA;AA7BH;AAgCE;EACC,qCAAA;AA9BH;AAmCC;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;AAjCF;AAmCE;EAND;IAOE,sBAAA;IACA,mBAAA;EAhCD;AACF;AAkCE;EACC,kBAAA;AAhCH;AAkCG;EAHD;IAIE,kBAAA;EA/BF;AACF;;AAoCA;EACC,aAAA;EACA,qCAAA;EACA,SAAA;AAjCD;AAmCC;EALD;IAME,qCAAA;EAhCA;AACF;;AAuCA;EACC,WAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,4CAAA;AApCD;;AAwCC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AArCF;AAuCE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AArCH;AAuCG;EACC,aAAA;EACA,2DAAA;EACA,eAAA;EACA,mBAAA;AArCJ;AAuCI;EAND;IAOE,sCAAA;EApCH;AACF;AA2CG;;EAEC,oBAAA;AAzCJ;AA4CG;EACC,gBAAA;AA1CJ;AA6CG;EACC,eAAA;AA3CJ;AA+CI;EACC,qBAAA;AA7CL;AAgDI;EACC,wCAAA;EACA,qBAAA;AA9CL;AAgDK;EACC,wCAAA;EACA,qBAAA;AA9CN;;AAsDA;EACC,sBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;AAnDD;AAqDC;EACC,4BAAA;AAnDF;AAsDC;EACC,yBAAA;AApDF;AAuDC;EACC,yBAAA;AArDF;;AA0DC;EACC,YAAA;EACA,gBAAA;AAvDF;AAyDE;EACC,gBAAA;EACA,eAAA;AAvDH;AAyDG;EACC,gBAAA;EACA,2BAAA;AAvDJ;AA2DE;EACC,0CAAA;EACA,cAAA;AAzDH;AA6DC;EACC,WAAA;AA3DF;AA6DE;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AA3DH;AA+DC;EACC,YAAA;AA7DF;AAgEC;EACC,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA9DF;AAgEE;EACC,kBAAA;AA9DH;AAkEC;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAhEF;AAkEE;EACC,mBAAA;AAhEH;AAoEC;EACC,WAAA;EACA,gBAAA;EACA,oCAAA;AAlEF;AAoEE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAlEH;AAoEG;EACC,aAAA;EACA,4DAAA;EACA,eAAA;EACA,mBAAA;AAlEJ;AAoEI;EAND;IAOE,yCAAA;EAjEH;AACF;AAwEG;;EAEC,oBAAA;AAtEJ;AAyEG;EACC,gBAAA;AAvEJ;AA0EG;EACC,eAAA;AAxEJ;AA4EI;EACC,qBAAA;AA1EL;AA6EI;EACC,wCAAA;EACA,qBAAA;AA3EL;AA6EK;EACC,wCAAA;EACA,qBAAA;AA3EN;AA8EK;EACC,gBAAA;AA5EN;;AAoFA;EACC,aAAA;EACA,gBAAA;EACA,mBAAA;AAjFD;AAmFC;EACC,kBAAA;AAjFF;AAoFC;EACC,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,mCAAA;AAlFF;AAqFC;EACC,WAAA;EACA,sCAAA;AAnFF;;AAuFA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AApFD;AAsFC;EACC,YAAA;AApFF;;AAwFA;EACC,YAAA;AArFD;AAuFC;EACC,kBAAA;EACA,WAAA;AArFF;AAwFC;EACC,kBAAA;EACA,aAAA;AAtFF;AAyFC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;AAvFF;AA0FC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;AAxFF;AA0FE;EACC,aAAA;EACA,6CAAA;EACA,mBAAA;EACA,6CAAA;AAxFH;AAmGE;EACC,gBAAA;EACA,2BAAA;AAjGH;AAoGE;EACC,eAAA;AAlGH;AAsGG;EACC,gBAAA;AApGJ;AAuGG;EACC,eAAA;AArGJ;AAyGI;EACC,gBAAA;AAvGL;;AA8GA;EACC,YAAA;AA3GD;AA6GC;EACC,YAAA;AA3GF;AA6GE;EACC,oCAAA;AA3GH;AA8GE;EACC,6CAAA;AA5GH;AA+GE;EACC,oCAAA;AA7GH;AAgHE;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,8BAAA;AA9GH;AAkHI;;EACC,aAAA;EACA,qCAAA;EACA,mBAAA;AA/GL;AAiHK;;EACC,mBAAA;EACA,gBAAA;AA9GN;AAiHK;;EACC,iBAAA;EACA,gBAAA;AA9GN;AAkHI;;EACC,eAAA;AA/GL;AAmHG;EACC,2BAAA;AAjHJ;;AAuHA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApHD;;AAuHA;EACC,aAAA;EACA,mBAAA;AApHD;;AAuHA;EACC,WAAA;EACA,gBAAA;EACA,iBAAA;AApHD;AAsHC;EACC,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AApHF;AAsHE;EACC,eAAA;EACA,mBAAA;AApHH;AAuHE;;EAEC,oBAAA;AArHH;AAwHE;EACC,gBAAA;AAtHH;AAyHE;EACC,mBAAA;AAvHH;AAyHG;EACC,mCAAA;EACA,mBAAA;EACA,yBAAA;AAvHJ;AA4HG;EACC,oCAAA;AA1HJ;AA4HI;EACC,yCAAA;AA1HL;AA+HE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,wBAAA;EACA,kBAAA;EACA,WAAA;AA7HH;AAgIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AA9HH;AAiIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA/HH;AAkIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AAhIH;AAmIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAjIH;AAoIE;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;AAlIH;AAqIE;EACC,gBAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;AAnIH;;AAwIA;EACC,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AArID;AAuIC;EAXD;IAYE,QAAA;EApIA;AACF;AAgJC;EACC,WAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;AA9IF;AAgJE;EACC,oBAAA;AA9IH;AAkJC;EACC,aAAA;EACA,eAAA;AAhJF;AAmJE;EACC,kBAAA;AAjJH;AAqJC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAnJF;AAsJC;EACC,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,mBAAA;AApJF;;AAwJA;EACC,aAAA;EACA,oCAAA;EACA,YAAA;EACA,kBAAA;AArJD;AAuJC;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AArJF;AAwJC;EACC,mCAAA;EACA,mBAAA;AAtJF;AAyJC;EACC,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,0BAAA;AAvJF;AA0JC;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AAxJF;AA2JC;EACC,qCAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AAzJF;AA4JC;EACC,kBAAA;EACA,SAAA;EACA,aAAA;AA1JF;AA4JE;EACC,oCAAA;EACA,YAAA;AA1JH;AA4JG;EACC,oCAAA;AA1JJ;;AAgKA;EACC,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,oCAAA;EACA,YAAA;EAEA,mBAAA;EACA,eAAA;AA9JD;AAgKC;EACC,sBAAA;EACA,kBAAA;AA9JF;AAiKC;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AA/JF;AAiKE;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AA/JH;AAmKC;EACC,sCAAA;EACA,4BAAA;EACA,oBAAA;AAjKF;AAmKE;EACC,sCAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;AAjKH;;AAuKC;EACC,YAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AApKF;AAuKC;EACC,wCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,oBAAA;AArKF;AAuKE;EACC,wCAAA;AArKH;;AA0KA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAvKD;AAyKC;EACC,kBAAA;AAvKF;AAyKE;EAHD;IAIE,eAAA;EAtKD;EA0JF;IAiBE,sBAAA;IACA,SAAA;EAtKA;AALF;;AAkLC;EACC,aAAA;EACA,8BAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAzKF;AA4KC;EACC,YAAA;AA1KF;AA6KC;EACC,aAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,uCAAA;EACA,mBAAA;AA3KF;AA6KE;EACC,aAAA;AA3KH;AA6KG;EACC,aAAA;EACA,mBAAA;AA3KJ;AA6KI;EACC,iBAAA;EACA,wBAAA;AA3KL;;AAkLA;EACC,aAAA;AA/KD;;AAkLA;EACC,yBAAA;AA/KD;;AAkLA;EACC,aAAA;EACA,uBAAA;EACA,gBAAA;AA/KD;AAiLC;EACC,kBAAA;AA/KF;AAkLC;EATD;IAUE,sBAAA;IACA,mBAAA;EA/KA;EAiLA;IACC,eAAA;IACA,mBAAA;EA/KD;AACF;;AAoLA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AAjLD;AAmLC;EACC,aAAA;EACA,iBAAA;AAjLF;AAoLC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AAlLF;AAoLE;EACC,4DAAA;EAEA,wCAAA;EACA,2BAAA;AAnLH;AAsLE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DAAA;EAEA,wCAAA;EACA,2BAAA;AArLH;AA0LC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAzLF;AA6LE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA3LH;AA+LE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AA7LH;AA+LG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AA7LJ;;AAmMA;EACC,aAAA;EACA,oBAAA;EACA,sBAAA;AAhMD;;AAmMA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAhMD;AAkMC;EALD;IAME,sBAAA;IACA,uBAAA;IACA,mBAAA;EA/LA;AACF;;AAkMA;EACC,YAAA;EACA,oCAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA/LD;AAiMC;EACC,aAAA;EACA,8BAAA;AA/LF;;AAmMA;EACC,mBAAA;EACA,gBAAA;AAhMD;AAkMC;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAhMF;;AAoMA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;AAjMD;AAmMC;EALD;IAME,mBAAA;IACA,8BAAA;IACA,SAAA;EAhMA;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.modal {\n\t&__img {\n\t\theight: 7.5rem;\n\t\tmargin-bottom: 3rem;\n\t}\n}\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tflex-wrap: wrap;\n\t\tmargin-top: 2rem;\n\t\tpadding: 0 2rem;\n\t\t// border-top: solid 1px var(--color-primary);\n\t\tbackground-color: var(--color-white);\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tborder-radius: 1rem 1rem 0 0;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\n\t\t&_group {\n\t\t\tposition: relative;\n\t\t}\n\n\t\t&_more {\n\t\t\tposition: absolute;\n\t\t\tright: 0;\n\t\t\ttop: 75%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tpadding: 1.5rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\t\t\tz-index: 5;\n\n\t\t\t&> :not(last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \twidth: 47%;\n\t\t\t// }\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t\tfont-size: var(--default-font-small);\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tborder-bottom: solid 2px var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n\n\t&__metrics {\n\t\twidth: 100%;\n\t\tdisplay: grid;\n\t\ttext-align: center;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-800) {\n\t\t\tgrid-template-columns: repeat(3, 1fr);\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\t;\n\t\t}\n\n\t\t&_container {\n\t\t\tbox-sizing: border-box;\n\t\t\tpadding: 2rem;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tborder-radius: 2rem;\n\t\t}\n\n\n\t\t// @media only screen and (max-width: $bp-500) {\n\t\t// \tgrid-template-columns: 100%;\n\t\t// }\n\n\t\t&_lightBlue {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t}\n\n\t\t&_grey {\n\t\t\tbackground-color: var(--color-grey-2);\n\t\t}\n\n\t\t&_lightBlue2 {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\n\t\t&_red {\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_green {\n\t\t\tbackground-color: var(--color-success);\n\t\t\tcolor: var(--color-white);\n\t\t}\n\n\t\t&_yellow {\n\t\t\tbackground-color: var(--color-yellow);\n\t\t}\n\t}\n\n\n\t&__dropdowns {\n\t\tmargin-top: 2rem;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tflex-direction: column;\n\t\t\talign-items: center;\n\t\t}\n\n\t\t&> :not(last-child) {\n\t\t\tmargin-right: 2rem;\n\n\t\t\t@media only screen and (max-width: $bp-700) {\n\t\t\t\tmargin-right: none;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.threeCards {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgap: 2rem;\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n\n\t// @media only screen and (max-width: $bp-500) {\n\t// \tgrid-template-columns: 100%;\n\t// }\n}\n\n.singleCard {\n\twidth: 100%;\n\tbackground-color: var(--color-white);\n\tpadding: 2rem;\n\tborder-radius: 2rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n}\n\n.payroll {\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 5% 18% 15% repeat(2, 12%) 9% 20% 10%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: 15% 40% 30% 15%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 2rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t&> :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.status {\n\tbox-sizing: border-box;\n\twidth: 5vw;\n\theight: 2vw;\n\tcolor: var(--color-error);\n\n\t&__pending {\n\t\tcolor: var(--color-yellow-3);\n\t}\n\n\t&__paid {\n\t\tcolor: var(--color-green);\n\t}\n\n\t&__failed {\n\t\tcolor: var(--color-error);\n\t}\n}\n\n.employee {\n\t&__list {\n\t\twidth: 38rem;\n\t\tmargin-top: 5rem;\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\n\t\t&_line {\n\t\t\tborder-top: 1px solid var(--color-primary);\n\t\t\tmargin: 2rem 0;\n\t\t}\n\t}\n\n\t&__avatar {\n\t\twidth: 9rem;\n\n\t\t&_container {\n\t\t\twidth: 10rem;\n\t\t\theight: 10rem;\n\t\t\tborder-radius: 7rem;\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tmargin: 3rem 0;\n\t\t}\n\t}\n\n\t&__details {\n\t\twidth: 38rem;\n\t}\n\n\t&__editButton {\n\t\tposition: relative;\n\t\tright: 17rem;\n\t\tdisplay: flex;\n\t\tfont-size: 2.5rem;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&__terminate {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 38rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\t}\n\n\t&_table {\n\t\twidth: 100%;\n\t\tmargin-top: 3rem;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 16% repeat(3, 15%) 15% 10% 10% 5% 15%;\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\talign-items: center;\n\n\t\t\t\t@media only screen and (max-width: $bp-800) {\n\t\t\t\t\tgrid-template-columns: repeat(2, 40%) 20%;\n\t\t\t\t}\n\n\t\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t\t// }\n\t\t\t}\n\n\t\t\tth,\n\t\t\ttd {\n\t\t\t\tpadding: 2.2rem 1rem;\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\n\t\t\ttd {\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\n\t\t\ttbody {\n\t\t\t\t&> :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tbackground-color: var(--color-primary-3);\n\t\t\t\t\tborder-radius: 1.3rem;\n\n\t\t\t\t\t&:nth-child(even) {\n\t\t\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\t\t\tborder-radius: 1.3rem;\n\t\t\t\t\t}\n\n\t\t\t\t\t&> :last-child {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.crumbs {\n\tdisplay: flex;\n\tmargin-top: 2rem;\n\tmargin-bottom: 1rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t&__main {\n\t\tcontent: '';\n\t\theight: 2rem;\n\t\twidth: 2rem;\n\t\tborder-radius: 2rem;\n\t\tbackground-color: var(--color-grey);\n\t}\n\n\t&__active {\n\t\twidth: 5rem;\n\t\tbackground-color: var(--color-primary);\n\t}\n}\n\n.checks {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 2rem;\n\n\t&_group {\n\t\twidth: 38rem;\n\t}\n}\n\n.gp {\n\twidth: 40rem;\n\n\t&__vb {\n\t\tposition: relative;\n\t\tleft: 20rem;\n\t}\n\n\t&__vps {\n\t\tposition: relative;\n\t\tleft: 16.5rem;\n\t}\n\n\t&__top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 44rem;\n\t\tmargin-bottom: 3rem;\n\t}\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: left;\n\t\tfont-size: var(--default-font-small);\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 2.6fr repeat(2, 1.2fr);\n\t\t\talign-items: center;\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\n\t\t\t// @media only screen and (max-width: $bp-900) {\n\t\t\t// \tgrid-template-columns: 2.3fr 1.6fr 2fr 0.9fr 0.2fr;\n\t\t\t// }\n\n\t\t\t// @media only screen and (max-width: $bp-600) {\n\t\t\t// \tgrid-template-columns: 1fr;\n\t\t\t// }\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t\tcolor: var(--color-primary);\n\t\t}\n\n\t\ttd {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\ttbody {\n\t\t\t&> :first-child {\n\t\t\t\tmargin-top: 1rem;\n\t\t\t}\n\n\t\t\t&>* {\n\t\t\t\tpadding: 1rem 0;\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\t&> :first-child {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ps {\n\twidth: 40rem;\n\n\t&__breakdown {\n\t\twidth: 38rem;\n\n\t\t&_sm {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\t&_bdr {\n\t\t\tborder-bottom: 1px solid var(--color-primary);\n\t\t}\n\n\t\t&_total {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\tmax-width: 100%;\n\t\t\tborder: none;\n\t\t\tborder-collapse: collapse;\n\t\t\tbox-sizing: border-box;\n\t\t\ttext-align: left;\n\t\t\tfont-size: var(--default-font);\n\n\t\t\tthead,\n\t\t\ttbody {\n\t\t\t\ttr {\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\t\t\talign-items: center;\n\n\t\t\t\t\t&> :first-child {\n\t\t\t\t\t\tjustify-self: start;\n\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t}\n\n\t\t\t\t\t&> :last-child {\n\t\t\t\t\t\tjustify-self: end;\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&>* {\n\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tth {\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.mp {\n\twidth: 38rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\n.success {\n\theight: 27rem;\n\tmargin-bottom: 3rem;\n}\n\n.simpleTable {\n\twidth: 100%;\n\tmargin-top: 3rem;\n\tfont-size: 1.2rem;\n\n\ttable {\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t\tborder: none;\n\t\tborder-collapse: collapse;\n\t\tbox-sizing: border-box;\n\t\ttext-align: center;\n\t\tmargin-top: 2rem;\n\n\t\ttr {\n\t\t\tpadding: 0 1rem;\n\t\t\talign-items: center;\n\t\t}\n\n\t\tth,\n\t\ttd {\n\t\t\tpadding: 1.2rem 2rem;\n\t\t}\n\n\t\tth {\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tthead {\n\t\t\tmargin-bottom: 2rem;\n\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-dark);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t\tcolor: var(--color-white);\n\t\t\t}\n\t\t}\n\n\t\ttbody {\n\t\t\ttr {\n\t\t\t\tbackground-color: var(--color-white);\n\n\t\t\t\t&:nth-child(even) {\n\t\t\t\t\tbackground-color: var(--color-table-grey);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.pending {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-yellow);\n\t\t\tcolor: var(--color-dark);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.paid {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-success);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.low {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-error);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 60%;\n\t\t}\n\n\t\t.inStock {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary-8);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 60%;\n\t\t}\n\n\t\t.others {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-dark);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.change {\n\t\t\tdisplay: inline-flex;\n\t\t\tjustify-content: center;\n\t\t\tline-height: 1;\n\t\t\tfont-size: 1rem;\n\t\t\tborder-radius: 1rem;\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tmargin-top: 0.7rem;\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t.action__text {\n\t\t\tfont-weight: 600;\n\t\t\tcolor: var(--color-primary);\n\t\t\ttext-decoration: underline;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n}\n\n.filter {\n\tposition: absolute;\n\twidth: fit-content;\n\tright: 0;\n\ttop: 75%;\n\tbackground-color: var(--color-white);\n\tpadding: 1.5rem;\n\tborder-radius: 1rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tz-index: 3;\n\n\t@media only screen and (max-width: $bp-500) {\n\t\ttop: 95%;\n\t}\n\n\t// clip-path: polygon(\n\t// \t48% 10%,\n\t// \t50% 0,\n\t// \t52% 10%,\n\t// \t100% 10%,\n\t// \t100% 100%,\n\t// \t0 100%,\n\t// \t0 10%\n\t// );\n\n\t&_title {\n\t\twidth: 100%;\n\t\tfont-size: var(--default-font-small);\n\t\tbackground-color: var(--color-light);\n\t\tpadding: 1rem;\n\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1.5rem;\n\t\t}\n\t}\n\n\t&_group {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\n\t\t// margin: 2rem 0;\n\t\t&> :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n\n\t&_item {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tmargin-bottom: 1rem;\n\t}\n\n\t&_selectedItem {\n\t\tfont-size: 1.2rem;\n\t\tpadding: 0.5rem;\n\t\tborder: 1px solid var(--color-dark);\n\t\tborder-radius: 0.8rem;\n\t\tcursor: pointer;\n\t\tcolor: var(--color-white);\n\t\tfont-weight: 700;\n\t\tbackground-color: var(--color-dark);\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.cpt {\n\tdisplay: flex;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\toverflow-x: scroll;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-white);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t&_action {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttext-decoration: underline;\n\t}\n\n\ttr {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: flex-start;\n\t\tpadding: 2rem;\n\t}\n\n\tthead {\n\t\tbackground-color: var(--color-grey-3);\n\t\twidth: 19rem;\n\t\tposition: fixed;\n\t\tz-index: 2;\n\t}\n\n\ttbody {\n\t\tposition: relative;\n\t\tleft: 50%;\n\t\tdisplay: flex;\n\n\t\ttr {\n\t\t\tbackground-color: var(--color-light);\n\t\t\twidth: 19rem;\n\n\t\t\t&:nth-child(even) {\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.beneficiary {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tbox-sizing: border-box;\n\tfont-size: var(--default-font-small);\n\twidth: 38rem;\n\n\tmargin-bottom: 3rem;\n\tcursor: pointer;\n\n\t&>* {\n\t\tpadding: 1rem 0 1rem 0;\n\t\ttext-align: center;\n\t}\n\n\t&__saved {\n\t\tbackground-color: var(--color-primary);\n\t\tcolor: var(--color-white);\n\t\tborder-radius: 1rem 0 0 1rem;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tborder: 1px solid var(--color-primary);\n\t\t\tborder-radius: 1rem 0 0 1rem;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n\n\t&__new {\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t\ttransition: all 0.4s;\n\n\t\t&_b {\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tborder-radius: 0 1rem 1rem 0;\n\t\t\ttransition: all 0.4s;\n\t\t}\n\t}\n}\n\n.unit {\n\t&_group {\n\t\twidth: 38rem;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 50%);\n\t\tgap: 2rem;\n\t}\n\n\t&_card {\n\t\tbackground-color: var(--color-primary-3);\n\t\tpadding: 2rem;\n\t\tbox-sizing: border-box;\n\t\tborder-radius: 2rem;\n\t\tfont-size: 4rem;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-direction: column;\n\t\tcolor: var(--color-primary);\n\t\tcursor: pointer;\n\t\ttransition: all 0.4s;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t}\n\t}\n}\n\n.searchbtnsection {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 0 2rem;\n\tmargin-top: 2rem;\n\n\t&> :not(:last-child) {\n\t\tmargin-right: 2rem;\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tflex-direction: column;\n\t\tgap: 2rem;\n\t}\n\n}\n\n.addProduct {\n\n\t&__beside {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\twidth: 38rem;\n\t\tmargin-bottom: 3rem;\n\t\tmargin-top: 3rem;\n\t}\n\n\t&__note {\n\t\twidth: 38rem;\n\t}\n\n\t&__variation {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tgap: 20px 0;\n\t\tpadding: 10px 20px;\n\t\tbackground-color: var(--color-primary-09);\n\t\tbox-shadow: 0 0 5px rgba(0, 0, 0, 0.08);\n\t\tborder-radius: 10px;\n\n\t\t&_info {\n\t\t\tflex: 0 0 50%;\n\n\t\t\t&_price {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\n\t\t\t\tsvg {\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\tcolor: var(--color-dark);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.imageUpload {\n\theight: 10rem;\n}\n\n.lengthColor {\n\tcolor: var(--color-error);\n}\n\n.middleButtons {\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\n\t&>:not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n\n\t@media only screen and (max-width: $bp-500) {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t&>:not(:last-child) {\n\t\t\tmargin-right: 0;\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg)\n\t\t}\n\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow: 10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.searchContainer {\n\tdisplay: flex;\n\tjustify-self: center;\n\tmax-width: fit-content;\n}\n\n.searchAndFilter {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 4rem;\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n}\n\n.card {\n\twidth: 38rem;\n\tbackground-color: var(--color-white);\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\tborder-radius: 8px;\n\tpadding: 2rem;\n\tmargin-bottom: 2rem;\n\n\t&_top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n}\n\n.type {\n\tmargin-bottom: 2rem;\n\tmargin-top: 2rem;\n\n\t&_rcb {\n\t\tdisplay: flex;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\twidth: 38rem;\n\t\tmargin-top: 2rem;\n\t}\n}\n\n.btnClass {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 2rem;\n\t\n\t@media only screen and (max-width: $bp-700) {\n\t\talign-items: center;\n\t\tflex-direction: column-reverse;\n\t\tgap: 2rem;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal__img": `Inventory_modal__img__BcFb5`,
	"main_nav": `Inventory_main_nav__gKIqG`,
	"main_nav_group": `Inventory_main_nav_group__t-7Sy`,
	"main_nav_more": `Inventory_main_nav_more__WQuzL`,
	"main_nav_item": `Inventory_main_nav_item__vvwEF`,
	"main_nav_item_active": `Inventory_main_nav_item_active__kUACa`,
	"main__metrics": `Inventory_main__metrics__55glC`,
	"main__metrics_container": `Inventory_main__metrics_container__k3QsK`,
	"main__metrics_lightBlue": `Inventory_main__metrics_lightBlue__+kaQv`,
	"main__metrics_grey": `Inventory_main__metrics_grey__ObfM4`,
	"main__metrics_lightBlue2": `Inventory_main__metrics_lightBlue2__E3ZWe`,
	"main__metrics_red": `Inventory_main__metrics_red__g0AfG`,
	"main__metrics_green": `Inventory_main__metrics_green__GQfvC`,
	"main__metrics_yellow": `Inventory_main__metrics_yellow__0X+v4`,
	"main__dropdowns": `Inventory_main__dropdowns__XlsdE`,
	"threeCards": `Inventory_threeCards__PK75t`,
	"singleCard": `Inventory_singleCard__5N9ML`,
	"payroll_table": `Inventory_payroll_table__HTafZ`,
	"status": `Inventory_status__9HNE1`,
	"status__pending": `Inventory_status__pending__TT0cd`,
	"status__paid": `Inventory_status__paid__DtKxT`,
	"status__failed": `Inventory_status__failed__KVuOW`,
	"employee__list": `Inventory_employee__list__Scd2i`,
	"employee__list_line": `Inventory_employee__list_line__q+p7k`,
	"employee__avatar": `Inventory_employee__avatar__-o78z`,
	"employee__avatar_container": `Inventory_employee__avatar_container__uaiJ0`,
	"employee__details": `Inventory_employee__details__tcRZo`,
	"employee__editButton": `Inventory_employee__editButton__Q15tr`,
	"employee__terminate": `Inventory_employee__terminate__mdIL0`,
	"employee_table": `Inventory_employee_table__snPK-`,
	"crumbs": `Inventory_crumbs__y0n8w`,
	"crumbs__main": `Inventory_crumbs__main__IBpZC`,
	"crumbs__active": `Inventory_crumbs__active__bWopu`,
	"checks": `Inventory_checks__frlcO`,
	"checks_group": `Inventory_checks_group__v52ga`,
	"gp": `Inventory_gp__uLuUf`,
	"gp__vb": `Inventory_gp__vb__oKckA`,
	"gp__vps": `Inventory_gp__vps__XpZY5`,
	"gp__top": `Inventory_gp__top__m-cDK`,
	"ps": `Inventory_ps__gmEJu`,
	"ps__breakdown": `Inventory_ps__breakdown__DkKwR`,
	"ps__breakdown_sm": `Inventory_ps__breakdown_sm__-XVs5`,
	"ps__breakdown_bdr": `Inventory_ps__breakdown_bdr__9Ob8d`,
	"ps__breakdown_total": `Inventory_ps__breakdown_total__ci1op`,
	"mp": `Inventory_mp__Yons6`,
	"success": `Inventory_success__2VUDc`,
	"simpleTable": `Inventory_simpleTable__u0m6Y`,
	"pending": `Inventory_pending__04Uz6`,
	"paid": `Inventory_paid__fRn2P`,
	"low": `Inventory_low__S26L3`,
	"inStock": `Inventory_inStock__DqGb4`,
	"others": `Inventory_others__B7+3e`,
	"change": `Inventory_change__P4XGD`,
	"action__text": `Inventory_action__text__uyeSY`,
	"filter": `Inventory_filter__qhLnu`,
	"filter_title": `Inventory_filter_title__u07+2`,
	"filter_group": `Inventory_filter_group__zR2NY`,
	"filter_item": `Inventory_filter_item__eDDPY`,
	"filter_selectedItem": `Inventory_filter_selectedItem__5p3Lk`,
	"cpt": `Inventory_cpt__XGAwb`,
	"cpt_action": `Inventory_cpt_action__Ctc3f`,
	"beneficiary": `Inventory_beneficiary__vJQo-`,
	"beneficiary__saved": `Inventory_beneficiary__saved__Lxh-c`,
	"beneficiary__saved_b": `Inventory_beneficiary__saved_b__0fv+O`,
	"beneficiary__new": `Inventory_beneficiary__new__YHhKP`,
	"beneficiary__new_b": `Inventory_beneficiary__new_b__q5FGC`,
	"unit_group": `Inventory_unit_group__E8yp+`,
	"unit_card": `Inventory_unit_card__7MkzH`,
	"searchbtnsection": `Inventory_searchbtnsection__eyUa2`,
	"addProduct__beside": `Inventory_addProduct__beside__WhMGr`,
	"addProduct__note": `Inventory_addProduct__note__Jw0NN`,
	"addProduct__variation": `Inventory_addProduct__variation__C4kUE`,
	"addProduct__variation_info": `Inventory_addProduct__variation_info__lbRNz`,
	"addProduct__variation_info_price": `Inventory_addProduct__variation_info_price__Im0V5`,
	"imageUpload": `Inventory_imageUpload__6Wnl1`,
	"lengthColor": `Inventory_lengthColor__6bEy1`,
	"middleButtons": `Inventory_middleButtons__SqjPY`,
	"selectCurrency": `Inventory_selectCurrency__UcGSt`,
	"selectCurrency__text": `Inventory_selectCurrency__text__XQE1q`,
	"selectCurrency__icon": `Inventory_selectCurrency__icon__49ugK`,
	"selectCurrency__icon_active": `Inventory_selectCurrency__icon_active__XOWgO`,
	"selectCurrency__list": `Inventory_selectCurrency__list__ax0Xj`,
	"selectCurrency__list_active": `Inventory_selectCurrency__list_active__6b0QH`,
	"searchContainer": `Inventory_searchContainer__7Yhbn`,
	"searchAndFilter": `Inventory_searchAndFilter__LUUhY`,
	"card": `Inventory_card__ecmWq`,
	"card_top": `Inventory_card_top__MELu6`,
	"type": `Inventory_type__VhV6F`,
	"type_rcb": `Inventory_type_rcb__6hWNV`,
	"btnClass": `Inventory_btnClass__ekxvF`
};
export default ___CSS_LOADER_EXPORT___;
